import React, { useEffect, useState } from 'react';
import { AnswerStats, QuestionStats } from 'src/redux/survey/survey.types';
import OverviewAnswerFeedback from './overview-answer-feedback';
import { Button } from 'src/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from 'src/components/ui/dropdown-menu';
import { Filter } from 'lucide-react';

interface OverviewDetailsProps {
  show: boolean;
  question: QuestionStats;
}

const SentimentItems = [
  {
    id: '1',
    title: 'Positive',
  },
  {
    id: '2',
    title: 'Negative',
  },
  {
    id: '3',
    title: 'Neutral',
  },
];

const OverviewDetails: React.FC<OverviewDetailsProps> = ({ show, question }) => {

  const [selectedItems, setSelectedItems] = useState<AnswerStats[]>(question.answers);
  const [selectedView, setSelectedView] = useState<'summary' | 'feedback' | 'analysis'>('feedback');
  const [filteredFeedback, setFilteredFeedback] = useState<AnswerStats[]>([]);

  useEffect(() => {
    setFilteredFeedback(question.answers.filter(answer => selectedItems.some(selectedItem => selectedItem.id === answer.id)));
  }, [selectedItems, question.answers]);

  const handleAnswerSelection = (answer: AnswerStats) => {
    if (selectedItems.some(selectedItem => selectedItem.id === answer.id)) {
      setSelectedItems(selectedItems.filter(selectedItem => selectedItem.id !== answer.id));
    } else {
      setSelectedItems([...selectedItems, answer]);
    }
  };

  //   const handleSentimentSelection = (sentiment: string) => {
  //     if (selectedItems.some(selectedItem => selectedItem.id === sentiment.id)) {
  //       setSelectedItems(selectedItems.filter(selectedItem => selectedItem.id !== sentiment.id));
  //     } else {
  //       setSelectedItems([...selectedItems, sentiment]);
  //     }
  //   };

  return (
    <div>
      <div className="flex flex-row items-center mt-2 justify-between ">
        {selectedView === 'feedback' && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outline"
                size="sm"
              >
                <Filter className="w-4 h-4" />
                Filter
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <div className="flex flex-col w-full">
                <div className="text-sm text-gray-700 font-medium p-2 px-4 w-full min-w-[200px] border-b border-gray-201">
                  Answers
                </div>
                {question.answers.map(item => (
                  <div
                    onClick={() => handleAnswerSelection(item)}
                    key={item.id}
                    className={`text-sm text-gray-700 font-medium p-2 px-4 w-full min-w-[200px] cursor-pointer ${selectedItems.some(selectedItem => selectedItem.id === item.id) ? 'bg-blue-500 text-white hover:bg-blue-300 hover:text-white' : 'hover:bg-gray-200 hover:text-gray-700'}`}
                  >
                    {item.title}
                  </div>
                ))}
                <div className="text-sm text-gray-700 font-medium p-2 px-4 w-full min-w-[200px] border-b border-gray-201">
                  Sentiment
                </div>
                {SentimentItems.map(item => (
                  <div
                    onClick={() => {}}
                    key={item.id}
                    className={`text-sm text-gray-700 font-medium p-2 px-4 w-full min-w-[200px] cursor-pointer ${selectedItems.some(selectedItem => selectedItem.id === item.id) ? 'bg-blue-500 text-white hover:bg-blue-300 hover:text-white' : 'hover:bg-gray-200 hover:text-gray-700'}`}
                  >
                    {item.title}
                    {/* <div className={`text-xs font-normal ${selectedItems.some(selectedItem => selectedItem.id === item.id) ? '' : ''}`}>
                    {item.id}
                  </div> */}
                  </div>
                ))}
              </div>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        <div className="flex flex-row gap-2 border border-gray-200 rounded-full ml-auto">
          <Button
            variant={selectedView === 'summary' ? 'primary' : 'ghost'}
            size="sm"
            onClick={() => setSelectedView('summary')}
          >
            Summary
          </Button>
          <Button
            variant={selectedView === 'feedback' ? 'primary' : 'ghost'}
            size="sm"
            onClick={() => setSelectedView('feedback')}
          >
            Feedback
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setSelectedView('analysis')}
          >
            Analysis
          </Button>

        </div>
      </div>
      {show && (
        selectedView === 'feedback' ? (
          filteredFeedback.map((answer) => answer.feedbacks?.aiAnswers.map((feedback) => (
            <OverviewAnswerFeedback
              key={feedback.createdAt}
              feedback={feedback.feedback}
              createdAt={feedback.createdAt}
            />
          )))
        ) : (
          <div>
            Summary
          </div>
        )
      )}
    </div>
  );
};

export default OverviewDetails;
